export default "__VITE_ASSET__XNxeI$3o__"